import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';

import "./Tabs.scss";

class Tabs extends Component { 
  static propTypes = {
    tabs: PropTypes.array.isRequired,
    activeTab: PropTypes.number.isRequired,
    onClickTab: PropTypes.func.isRequired,
  };

  renderTabs = (tab, i) => {
    const { activeTab, onClickTab } = this.props;

    const tabClass = classnames({
      'tab': true,
      'active': tab.value === activeTab,
    });

    return(
      <div className={tabClass}
        key={`tab-${tab.name}-${i}`}
        onClick={() => onClickTab(tab)}
      >
        {tab.name}
        <div className="bottom-border" />
      </div>
    );
  }


  render() {
    const { tabs } = this.props;

    return (
      <div className="tabs-wrapper">
        {tabs.map(this.renderTabs)}
      </div>
    );
  }
}

export default Tabs;
